<template>
  <div>
    <table width="100%">
      <tr>
     <td>
       <my-header></my-header>
     </td>
      </tr>
    </table>
    <h3 style="text-align: center; font-weight: bold">In House Faculty</h3>
    <table style="margin-top: 20px; width: 100%" v-for="campus in record">
      <thead>
        <tr>
          <th class="text-center">
            <h4 style="width: 100%">{{campus.EmpCode}} - {{campus.Name}} - {{campus.Designation}}</h4>
          </th>
        </tr>
      </thead>
      <tr>
        <td>
          <table style="width: 100%; border-collapse: collapse; font-size: 12px" border="1">
            <thead class="bg-info">
              <tr  style="background-color: darkgrey;">
                <th rowspan="2" style="text-align: center" width="10%">Course Code</th>
                <th rowspan="2" style="text-align: center" width="30%">Course Name</th>
                <th rowspan="2" style="text-align: center" width="30%">Program</th>
                <th rowspan="2" style="text-align: center" width="15%">No Of Students</th>
                <th colspan="3" style="text-align: center" width="15%">Credit Hours</th>
              </tr>
              <tr style="border-top: 1px solid black; background-color:darkgrey;">
                <th style="text-align: center" width="5%">Th</th>
                <th style="text-align: center" width="5%">Lb</th>
                <th style="text-align: center" width="5%">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="inq in campus.Courses">
                <td>{{inq.Code}}</td>
                <td>{{inq.CourseName}}</td>
                <td>{{inq.ProgramName}}</td>
                <td style="text-align: center">{{inq.NoOfStudents}}</td>
                <td style="text-align: center">{{inq.Theory}}</td>
                <td style="text-align: center">{{inq.Lab}}</td>
                <td style="text-align: center">{{inq.CreditHours}}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr style="text-align: center; font-weight: bolder">
                <td colspan="4">
                  Total Credit Hours
                </td>
                <td>
                  {{campus.ThTotal}}
                </td>
                <td>
                  {{campus.LbTotal}}
                </td>
                <td>
                  {{campus.ThTotal + campus.LbTotal}}
                </td>
              </tr>
            </tfoot>
            
          </table>
        </td>
      </tr>
    </table>

    <h3 style="text-align: center; font-weight: bold" v-if="visrecord != 0">Visiting Faculty</h3>
    <table style="margin-top: 20px; width: 100%" v-for="campus in visrecord">
      <thead>
        <tr>
          <th class="text-center">
            <h4 style="width: 100%">{{campus.EmpCode}} - {{campus.Name}} - {{campus.Designation}}</h4>
          </th>
        </tr>
      </thead>
      <tr>
        <td>
          <table style="width: 100%; border-collapse: collapse; font-size: 12px" border="1">
            <thead class="bg-info">
              <tr >
                <th rowspan="2" style="text-align: center" width="10%">Course Code</th>
                <th rowspan="2" style="text-align: center" width="30%">Course Name</th>
                <th rowspan="2" style="text-align: center" width="30%">Program</th>
                <th rowspan="2" style="text-align: center" width="15%">No Of Students</th>
                <th colspan="3" style="text-align: center" width="15%">Credit Hours</th>
              </tr>
              <tr style="border-top: 1px solid black; ">
                <th style="text-align: center" width="5%">Th</th>
                <th style="text-align: center" width="5%">Lb</th>
                <th style="text-align: center" width="5%">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="inq in campus.Courses">
                <td>{{inq.Code}}</td>
                <td>{{inq.CourseName}}</td>
                <td>{{inq.ProgramName}}</td>
                <td style="text-align: center">{{inq.NoOfStudents}}</td>
                <td style="text-align: center">{{inq.Theory}}</td>
                <td style="text-align: center">{{inq.Lab}}</td>
                <td style="text-align: center">{{inq.CreditHours}}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr style="text-align: center; font-weight: bolder">
                <td colspan="4">
                  Total Credit Hours
                </td>
                <td>
                  {{campus.ThTotal}}
                </td>
                <td>
                  {{campus.LbTotal}}
                </td>
                <td>
                  {{campus.ThTotal + campus.LbTotal}}
                </td>
              </tr>
            </tfoot>
            
          </table>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        record: [],
        visrecord: [],
      }
    },
    created: function () {
      this.loadRecord();
    },

    methods:
    {
      loadRecord() {
        var vm = this;
        const params = new URLSearchParams(window.location.search);
        const ActiveSemesterID = params.get('sessID');
        const EmployeeRegistrationID = params.get('EmpID');
        axios.post('/api/DCApi/loadInstructorRecord?sessID=' + ActiveSemesterID + '&EmpID=' + EmployeeRegistrationID)
          .then(function (response) {
            vm.record = response.data.empWise;
            vm.visrecord = response.data.empWisevis;
          })
      },
    },
  })
</script>



// WEBPACK FOOTER //
// src/components/DC/instructorWorkLoadPrint.vue